module.exports = __webpack_public_path__ + "static/img/avatar.f2de1a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar.jpg
// module id = lS+k
// module chunks = 22